import { Box, Typography } from '@mui/material';
import TransText from 'next-translate/TransText';
import { FC } from 'react';
import { LANDING_URL } from '@utils/consts/livv';
import type { LegalContent } from '@utils/types/legalContent';

const LegalContent: FC<LegalContent> = ({ sections }) => (
    <>
        {sections.map(({ subSections, title }) => (
            <Box key={title} component="section">
                {title && (
                    <Typography mt={5} variant="h2">
                        {title}
                    </Typography>
                )}
                {subSections.map(({ text, title: subSectionsTitle }) => (
                    <Box key={subSectionsTitle || text} mb={5}>
                        {subSectionsTitle && (
                            <Typography mt={1} variant="h3">
                                {subSectionsTitle}
                            </Typography>
                        )}
                        <TransText
                            components={{
                                br: <br />,
                                li: <li />,
                                livvLink: (
                                    // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
                                    <a
                                        href={`https://${LANDING_URL}`}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    />
                                ),
                                p: <p />,
                                strong: <strong />,
                                ul: <ul />,
                            }}
                            text={text}
                        />
                    </Box>
                ))}
            </Box>
        ))}
    </>
);

export default LegalContent;
